import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  refBookTitle: {
    id: 'refBookTitle',
    defaultMessage: 'Title',
  },
  refBookValue: {
    id: 'refBookValue',
    defaultMessage: 'Value',
  },
  refBookName: {
    id: 'refBookName',
    defaultMessage: 'Reference book name',
  },
  cantRemoveTheLast: {
    id: 'cantRemoveTheLast',
    defaultMessage: "You can't remove the last key-value",
  },
  minRefBook: {
    id: 'minRefBook',
    defaultMessage: 'Reference book must have at least one Key-Value.',
  },
  fieldEmpty: {
    id: 'fieldEmpty',
    defaultMessage: 'This field may not be blank',
  },
  addRefBookValue: {
    id: 'addRefBookValue',
    defaultMessage: 'Add new value',
  },
  refBookValues: {
    id: 'refBookValues',
    defaultMessage: 'Values list',
  },
});

export default { ...globalIntl, ...m };
